<template>
    <div id="loading" class="text-center">
        <SwappingSquaresSpinner id="icon" :animation-duration="1000" :size="iconSize" :color="sectionColor"/>
        <span v-if='text' :style="{ color: sectionColor, fontSize: this.fontSize + 'px' }" v-html="text"/>
    </div>
</template>

<script>
import SwappingSquaresSpinner from "epic-spinners/src/components/lib/HalfCircleSpinner";
import colors from "../../../helpers/colors";

export default {
    name: "APILoading",
    components: {SwappingSquaresSpinner},
    props: {
        text: {
            type: String,
            required: true,
        },
        iconSize: {
            type: Number,
            default: 50,
        },
        fontSize: {
            type: Number,
            default: 24,
        },
        color: {
            type: String,
            default: "#007BFF",
        },
    },
    computed: {
        sectionColor() {
            const section = this.$firstSectionPath;
            return colors[section] ? colors[section] : this.color;
        },
    },
};
</script>

<style scoped>
    #loading {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    #icon {
        margin: 5px;
    }
</style>